export const DefaultEventDetailsAdditionalPropertiesModel = {
    assetTypes: [],
    assetSubTypes: [],
    assetOwnerships: [],
    assetStatuses: []
};

export const DefaultEventDetailsAdditionalPropertiesConditionsModel = {
    conditions: DefaultEventDetailsAdditionalPropertiesModel
};

export const DefaultEventTypeDetailsModel = {
    adHoc: null,
    name: '',
    eventHelperText: '',
    additionalProperties: DefaultEventDetailsAdditionalPropertiesConditionsModel
};

export const DefaultCustomIconModel = {
    iconShape: null,
    iconSymbol: null
};

export const DefaultEventTypeIconModel = {
    eventIconName: '',
    eventIcon: null,
    customIcon: DefaultCustomIconModel
};

export const DefaultEventTypeProcessModel = {
    initialEventStatusId: 1,
    failStatusEnabled: false,
    requiresSignoff: false,
    requiresSignoffValue: "1",
    signoffHelperText: '',
    requiresSignoffFailedOnly: false,
    signoffRestricted: false,
    signoffSecondEnabled: false,
    signoffSecondRestricted: false, 
    employeeEdit: false
};

export const DefaultEventTypeSettingsModel = {
    includeComment: false,
    requireCommentValue: "1",
    requiresComment: false,
    requiresCommentFailedOnly: false,
    commentHelperText: '',
    includeDefect: false,
    requireDefectValue: "1",
    requiresDefect: false,
    requiresDefectFailedOnly: false,
    defectHelperText: '',
    includeDocumentation: false,
    includeDocumentationFailedOnly: false,
    requiresDocumentationCount: 0,
    documentationHelperText: ''
};

export const DefaultEventTypeScheduleModel = {
    adHoc: null,
    repeatFrequency: null,
    repeatInterval: 1,
    repeatCount: 1,
    vorTimerValue: "1",
    vorTimer: false,
    vorTimerFailedOnly: false,
    vorPreDays: 0,
    vorPostDays: 0,
};

export const DefaultEventTypeCostsModel = {
    includeCosts: false,
    requiresCosts: false,
    requiresCostsFailedOnly: false,
    requiresCostsValue: "1",
    costHelperText: '',
    includeSuppliers: false,
    requiresSuppliers: false,
    includeCostDocumentation: false,
    requiresCostDocumentationCount: 0,
};

export const DefaultEventTypeChecksModel = {
    enableChecks: false,
    relatedTemplates: []
};

export const DefaultEventTypeSummaryModel = {
    details: { ...DefaultEventTypeDetailsModel },
    icon: { ...DefaultEventTypeIconModel },
    process: { ...DefaultEventTypeProcessModel },
    settings: { ...DefaultEventTypeSettingsModel },
    schedule: { ...DefaultEventTypeScheduleModel },
    costs: { ...DefaultEventTypeCostsModel },
    checks: { ...DefaultEventTypeChecksModel }
};

export const EventTypeCustomIconSymbols = [
    { id: 1, key: "a", name: "A" },
    { id: 2, key: "b", name: "B" },
    { id: 3, key: "c", name: "C" },
    { id: 4, key: "d", name: "D" },
    { id: 5, key: "e", name: "E" },
    { id: 6, key: "f", name: "F" },
    { id: 7, key: "g", name: "G" },
    { id: 8, key: "h", name: "H" },
    { id: 9, key: "i", name: "I" },
    { id: 10, key: "j", name: "J" },
    { id: 11, key: "k", name: "K" },
    { id: 12, key: "l", name: "L" },
    { id: 13, key: "m", name: "M" },
    { id: 14, key: "n", name: "N" },
    { id: 15, key: "o", name: "O" },
    { id: 16, key: "p", name: "P" },
    { id: 17, key: "q", name: "Q" },
    { id: 18, key: "r", name: "R" },
    { id: 19, key: "s", name: "S" },
    { id: 20, key: "t", name: "T" },
    { id: 21, key: "u", name: "U" },
    { id: 22, key: "v", name: "V" },
    { id: 23, key: "w", name: "W" },
    { id: 24, key: "x", name: "X" },
    { id: 25, key: "y", name: "Y" },
    { id: 26, key: "z", name: "Z" },

    { id: 27, key: "0", name: "0" },
    { id: 28, key: "1", name: "1" },
    { id: 29, key: "2", name: "2" },
    { id: 30, key: "3", name: "3" },
    { id: 31, key: "4", name: "4" },
    { id: 32, key: "5", name: "5" },
    { id: 33, key: "6", name: "6" },
    { id: 34, key: "7", name: "7" },
    { id: 35, key: "8", name: "8" },
    { id: 36, key: "9", name: "9" },
];

export const DefaultEventTypes = [
    { id: 1, isAdHoc: false, name: "Scheduled" },
    { id: 2, isAdHoc: true, name: "Ad-hoc" }
];

export const DefaultSignoffOptions = [
    { value: "1", signoffRequired: false, label: "Not required" },
    { value: "2", signoffRequired: true, label: "Required" }
];

export const ErMaintenanceSignoffText = "I consider that any listed defects have been rectified satisfactorily, and this vehicle or trailer is now in a safe and roadworthy condition.";

export const FailedOnlySignoffOption = { value: "3", signoffRequired: true, label: "Only required for failed events" };

export const DefaultRequiredCommentOptions = [
    { value: "1", requiredComments: false, requiredCommentsFailedOnly: false, label: "Not required" },
    { value: "2", requiredComments: true, requiredCommentsFailedOnly: false, label: "Required" }
];

export const FailedOnlyCommentOption = { 
    value: "3", 
    requiredComments: true, 
    requiredCommentsFailedOnly: true, 
    label: "Only required for failed events" 
};

export const DefaultRequiredDefectOptions = [
    { value: "1", requiredDefects: false, requiredDefectsFailedOnly: false, label: "Not required" },
    { value: "2", requiredDefects: true, requiredDefectsFailedOnly: false, label: "Required" }
];

export const FailedOnlyDefectOption = {
    value: "3",
    requiredDefects: true,
    requiredDefectsFailedOnly: true,
    label: "Only required for failed events"
};

export const DefaultVorRequiredOptions = [
    { value: "1", vorRequired: false, vorRequiredFailedOnly: false, label: "Disabled" },
    { value: "2", vorRequired: true, vorRequiredFailedOnly: false, label: "Enabled" }
];

export const FailedVorRequiredOption = { value: "3", vorRequired: false, vorRequiredFailedOnly: true, label: "Only enabled for failed events" };

export const DefaultCostRequirementOptions = [
    { value: "1", label: "Not required" },
    { value: "2", label: "Required" }
];

export const FailedOnlyCostOption = { value: "3", label: "Only required for failed events" };